import MultiCheckbox from './MultiCheckbox';

export default MultiCheckbox;
